import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import * as memberStore from './member.store'
import * as shopStore from './shop.store'
import * as lineStore from './line.store'

Vue.use(Vuex)
// const sessionStorage = new VuexPersistence({
//   storage: window.sessionStorage, // or window.sessionStorage or localForage
//   modules: ['memberStore']
// })

const localStore = new VuexPersistence({
  storage: window.localStorage,
  modules: ['shopStore', 'memberStore', 'lineStore']
})

// sessionStorage.plugin

export default new Vuex.Store({
  modules: {
    memberStore,
    shopStore,
    lineStore
  },
  plugins: [localStore.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js